import { OrderTypeModalCallable } from 'pages/Trade/OrderTypeModal/OrderTypeModal';

export function CallableRoot() {
  return (
    <>
      <OrderTypeModalCallable.Root />
    </>
  );
}
